import MainBanner from './WEFAladinLanding/mainbanner.jsx';
import WEFDetectiveLanding from './WEFDetectiveLanding/WEFDetectiveLanding.jsx';

function App() {
  return (
    <MainBanner />
  );
}

export default App;
